import * as React from 'react';
import { Group, Text, useMantineTheme } from "@mantine/core";
import { Dropzone, FileWithPath } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconX } from "@tabler/icons-react";
import ImageRenderer from "./ImageRenderer";
import { clone } from "ramda";

interface MultiFileUploadProps {
    accept: string[];
    value: (string | FileWithPath)[];
    label: string;
    onChange: (value: (string | FileWithPath)[]) => void;
}

const MultiFileUpload = ({
    accept,
    label,
    value,
    onChange
}: MultiFileUploadProps) => {

    const theme = useMantineTheme();

    const handleImageRemove = (index: number) => {
        const cloned = clone(value);
        cloned.splice(index, 1);
        onChange(cloned);
    }

    return (
        <div>
            <Text size={14}>
                {label}
            </Text>
            <Dropzone
                onDrop={(files) => {
                    onChange([...value, ...files])
                }}
                accept={accept}
                multiple
            >
                <Group position="center" spacing="xl" style={{ minHeight: '2rem', pointerEvents: 'none' }}>
                    <Dropzone.Accept>
                        <IconUpload
                            size="3.2rem"
                            stroke={1.5}
                            color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
                        />
                    </Dropzone.Accept>
                    <Dropzone.Reject>
                        <IconX
                            size="3.2rem"
                            stroke={1.5}
                            color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
                        />
                    </Dropzone.Reject>
                    <Dropzone.Idle>
                        <IconPhoto size="3.2rem" stroke={1.5} />
                    </Dropzone.Idle>
                    <Text size="md">
                        ХУУЛАХ
                    </Text>
                </Group>
            </Dropzone>
            {
                value.map((item, index) => {
                    const key = typeof item === 'string' ? item : item.path;
                    return (
                        <ImageRenderer
                            key={key}
                            src={item}
                            onRemove={() => handleImageRemove(index)}
                        />
                    )
                })
            }
        </div>
    )
};

export default MultiFileUpload;